import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Select, SelectContent, SelectItem, SelectTrigger } from "@air/primitive-select";
import { tailwindMerge } from "@air/tailwind-variants";
import { memo, useMemo } from "react";
import { useTemporaryFeatureFlags } from "~/hooks/useTemporaryFeatureFlags";
const allLogicOptions = [
    "and",
    "or",
    "not"
];
export const FilterLogicSelect = /*#__PURE__*/ memo((param)=>{
    let { selectedLogic, onLogicChange, logicOptions = allLogicOptions, className } = param;
    const { searchImprovements } = useTemporaryFeatureFlags();
    const logicSelectOptions = useMemo(()=>{
        return [
            {
                value: "and",
                label: "Contains"
            },
            {
                value: "or",
                label: searchImprovements ? "Has one of" : "Contains one of..."
            },
            {
                value: "not",
                label: "Does not contain"
            }
        ];
    }, [
        searchImprovements
    ]);
    const availableOptions = useMemo(()=>logicSelectOptions.filter((option)=>logicOptions.includes(option.value)), [
        logicOptions,
        logicSelectOptions
    ]);
    return /*#__PURE__*/ _jsxs(Select, {
        onValueChange: onLogicChange,
        value: selectedLogic,
        children: [
            /*#__PURE__*/ _jsx(SelectTrigger, {
                className: tailwindMerge("mb-1 w-full", searchImprovements && "w-auto border-0 font-medium", className),
                placeholder: "Select logic",
                size: searchImprovements ? "small" : "large"
            }),
            /*#__PURE__*/ _jsx(SelectContent, {
                className: "min-w-[304px]",
                sideOffset: 4,
                children: availableOptions.map((option)=>/*#__PURE__*/ _jsx(SelectItem, {
                        value: option.value,
                        children: option.label
                    }, option.value))
            })
        ]
    });
});
FilterLogicSelect.displayName = "FilterLogicSelect";
